import * as React from 'react';

import FolderArrow140 from './FolderArrow140';

export const folderArrow140 = () => <FolderArrow140 />;

export default {
    title: 'Illustration/FolderArrow140',
    component: FolderArrow140,
    parameters: {
        notes: "`import FolderArrow140 from 'box-ui-elements/es/illustration/FolderArrow140';`",
    },
};
